import React from 'react';

const Loader = () => {
  return function() {
    return (
      <div className="loader_wrapper form_loader">
        <img src="/loader.gif" alt="loader" className="loader op"/>
      </div>
    );
  }()
};

export default Loader;